export default __webpack_public_path__ + "static/media/steelers.743c5168.png";